import { adminPagesSharedStyles, createAdminPageStyles, MUTED, NAVY, TEXT } from '../style';

export const useStyles = createAdminPageStyles({
  consultantRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 14,
    margin: '28px 0 32px',
  },
  avatar: {
    width: 48,
    height: 48,
    borderRadius: '50%',
    objectFit: 'cover',
    background: '#000B3314',
    color: TEXT,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    '& svg': {
      fontSize: 26,
    },
  },
  consultantMeta: {
    minWidth: 0,
    flex: 1,
  },
  consultantLabel: {
    fontFamily: 'Poppins',
    fontSize: 14,
    fontWeight: 500,
    color: TEXT,
    marginBottom: 2,
  },
  consultantNameRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  consultantName: {
    fontFamily: 'Poppins',
    fontSize: 16,
    fontWeight: 700,
    color: TEXT,
  },
  pencilBtn: {
    padding: 4,
    color: TEXT,
    '&:hover': {
      background: 'transparent',
      color: NAVY,
    },
    '& svg': {
      width: 16,
      height: 16,
      display: 'block',
    },
  },
  resourcesHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16,
    marginBottom: 22,
  },
  sectionTitle: {
    ...adminPagesSharedStyles.sectionTitle,
    margin: 0,
  },
  secondaryBtn: {
    ...adminPagesSharedStyles.secondaryBtn,
    '&:disabled': {
      color: MUTED,
    },
  },
  footer: {
    display: 'flex',
    gap: 12,
    marginTop: 16,
    paddingTop: 8,
    '@media (max-width: 700px)': {
      flexDirection: 'column',
    },
  },
});
